<template>
  <el-dialog
    title="功能配置"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleCloseOuter"
    class="mid-dialog"
  >
    <el-form :model="formData" label-position="top" ref="formRef" class="px-10px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="业务功能" prop="businessFunction" class="mt-80px flex flex-col">
            <tree-transfer
              :title="['未选择', '已选择']"
              :from_data="businessFunctionList"
              :to_data="formData.businessFunction"
              filter
              filter-placeholder="请输入"
            ></tree-transfer>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="基础功能" prop="basicFunction" class="mt-80px flex flex-col">
            <tree-transfer
              :title="['未选择', '已选择']"
              :from_data="basicFunctionList"
              :to_data="formData.basicFunction"
              filter
              filter-placeholder="请输入"
            ></tree-transfer>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleCloseOuter">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { FunctionInfoApi, ModelGenericConfigurationApi } from '@wiz-api/cloud-render-management'
import treeTransfer from 'el-tree-transfer'

const modelGenericConfigurationApi = new ModelGenericConfigurationApi()
const functionApi = new FunctionInfoApi()
export default {
  name: 'functionConfig',
  components: {
    treeTransfer,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editType: 'create',
      formData: {
        basicFunction: [],
        businessFunction: [],
      },
      basicFunctionList: [],
      businessFunctionList: [],
      saveLoading: false,
    }
  },
  computed: {
    functionAll() {
      return JSON.parse(
        JSON.stringify(_.concat(this.formData.basicFunction, this.formData.businessFunction))
      )
    },
  },
  async created() {
    // 获取功能树形列表
    await this.getSubTreeList()
    // 获取当时已配置列表
    await this.getConfigList()
  },
  methods: {
    // 关闭外部弹框的回调
    handleCloseOuter() {
      this.$emit('update:visible', false)
    },
    // 获取功能树形结构
    async getSubTreeList() {
      const [err, res] = await functionApi.getSubTrees()
      if (!err && res) {
        this.basicFunctionList = this.getTreeList(res, 1)
        this.businessFunctionList = this.getTreeList(res, 2)
      }
    },
    async getConfigList() {
      const [err, res] = await modelGenericConfigurationApi.getList()
      if (!err && res?.items.length) {
        this.editType = 'update'
        this.currentId = res.items[0].id

        const basicFunctionArr = this.arrToTree(res.items[0].extraDto.basicFunctionInfoDtos, null)
        const businessFunctionArr = this.arrToTree(
          res.items[0].extraDto.businessFunctionInfoDtos,
          null
        )
        this.$set(this.formData, 'basicFunction', basicFunctionArr)
        this.$set(this.formData, 'businessFunction', businessFunctionArr)
        this.handlerTree(this.basicFunctionList, basicFunctionArr)
        this.handlerTree(this.businessFunctionList, businessFunctionArr)
      }
    },
    // 根据已选择页面的权限 递归处理数据
    handlerTree(data, selectData) {
      const selData = _.cloneDeep(selectData)
      let flag = false
      for (let i = data.length - 1; i >= 0; i -= 1) {
        for (let j = selData.length - 1; j >= 0; j -= 1) {
          if (data[i] && data[i].id === selData[j].id) {
            // 当id相等可以删除的情况 即：没有子级可以删除；
            if (_.isEmpty(data[i].children)) {
              flag = true
              data.splice(i, 1)
            } else {
              const res = this.handlerTree(data[i].children, selData[j].children)
              res && i++
            }
          }
        }
      }
      return flag
    },
    // 树形化数组
    arrToTree(data, id) {
      const res = []
      _.forEach(data, (item) => {
        if (_.isNil(id) ? item.parentId === id : item.parentId === id) {
          res.push({
            pid: item.parentId,
            id: item.id,
            label: item.name,
            children: this.arrToTree(data, item.id),
            labelIds: item.extraProperties.lableIds,
            disabled: false,
          })
        }
      })
      return res
    },
    // 扁平化树形
    treeToArr(tree) {
      return tree.reduce((res, item) => {
        const { children, ...i } = item
        return res.concat(i, children && children.length ? this.treeToArr(children) : [])
      }, [])
    },
    // 获取树形穿梭框源数据
    getTreeList(data, type) {
      const res = []
      _.forEach(data, (item) => {
        if (item.detail.functionType === type) {
          const obj = {
            id: item.id,
            label: item.detail.name,
            pid: item.detail.parentId,
            labelIds: item.detail.extraProperties.lableIds,
            disabled: false,
          }
          if (!_.isEmpty(item.children)) {
            obj.children = this.getTreeList(item.children, type)
          } else {
            obj.children = []
          }
          res.push(obj)
        }
      })
      return res
    },
    // 保存新增编辑结果
    async save() {
      this.saveLoading = true
      let err
      let res
      if (this.editType === 'create') {
        ;[err, res] = await modelGenericConfigurationApi.create({
          body: {
            functionInfoIds: _.join(
              _.map(this.treeToArr(this.functionAll), (item) => {
                return item.id
              }),
              ','
            ),
          },
        })
      } else {
        ;[err, res] = await modelGenericConfigurationApi.update(this.currentId, {
          body: {
            functionInfoIds: _.join(
              _.map(this.treeToArr(this.functionAll), (item) => {
                return item.id
              }),
              ','
            ),
            id: this.currentId,
          },
        })
      }
      if (!err && res) {
        this.$message({
          showClose: true,
          message: '保存成功',
          type: 'success',
        })
        this.$emit('update:visible', false)
      }
      this.saveLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.mid-dialog {
  ::v-deep .el-dialog {
    .wl-transfer,
    .el-input,
    .el-select,
    .el-input-number {
      max-width: 440px;
      width: 100%;
      line-height: 36px;
    }
    .el-form {
      margin-left: 0 !important;
    }
    .transfer {
      .transfer-left,
      .transfer-right {
        width: 180px;
      }
      .transfer-center {
        display: flex;
        width: 80px;
        flex-direction: row-reverse;
        .transfer-center-item {
          padding: 8px;
        }
      }
      .el-button {
        line-height: 1;
        border-radius: 4px;
        width: 20px;
        height: 28px;
        padding: 0 2px;
        border: 1px solid rgb(220, 222, 226);
        i {
          color: rgb(229, 231, 235);
        }
        &.is-disabled {
          background-color: rgb(242, 246, 252);
          i {
            color: rgb(48, 49, 51);
          }
        }
      }
    }
  }
}
::v-deep .el-dialog.label-dialog {
  .el-transfer-panel {
    width: 180px;
  }
  .el-transfer__buttons {
    padding: 0 15px;
    .el-transfer__button + .el-transfer__button {
      margin-left: 0;
    }
  }
  .el-transfer-panel__filter {
    width: auto;
  }
}
</style>
